import { render, staticRenderFns } from "./KefuList.vue?vue&type=template&id=5884bd66&"
import script from "./KefuList.vue?vue&type=script&lang=js&"
export * from "./KefuList.vue?vue&type=script&lang=js&"
import style0 from "./KefuList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports